import { IAppliedDoc } from 'pages/application/applicationDocument/acknowledgmentDenialDismissal/type';
import { ReApplyDetailsType } from 'pages/application/reApply/type';
import { Actions, types } from './actions';

const initialState: ReApplyDetailsType | IAppliedDoc | any = {};

const reducer = (state = initialState, action: Actions) :ReApplyDetailsType | IAppliedDoc => {
  switch (action.type) {
    case types.SAVE_RE_APPLY_DOCUMENTS:
      return action.payload as ReApplyDetailsType | IAppliedDoc;
    case types.CLEAR_RE_APPLY_DOCUMENTS:
      return action.payload as ReApplyDetailsType | IAppliedDoc;
    default:
      return state;
  }
};

export default reducer;
